// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import cngMeetingDecisionEntity from './entities/cng-meeting-decision.json';
import cngMeetingDecisionMenu from '../pages/cng-meeting-decision/menu.json';
import cngMeetingDecisionFullForm from '../pages/cng-meeting-decision/forms/full.json';
import cngMeetingDecisionContextForm from '../pages/cng-meeting-decision/forms/context.json';
import cngMeetingDecisionMiniForm from '../pages/cng-meeting-decision/forms/mini.json';
import cngMeetingDecisionLookupForm from '../pages/cng-meeting-decision/forms/lookup.json';
import cngMeetingDecisionTableView from '../pages/cng-meeting-decision/views/table.json';
import cngMeetingDecisionCardsView from '../pages/cng-meeting-decision/views/cards.json';
import cngMeetingDecisionDashboardView from '../pages/cng-meeting-decision/views/dashboard.json';

/** Тип запису «Рішення засідання» зі сторінками пакета: меню, форми та подання з pages/cng-meeting-decision/. */
export const cngMeetingDecisionDefinition: IRecordTypeDefinition = {
  ...cngMeetingDecisionEntity,
  views: assembleViewSet({
      table: cngMeetingDecisionTableView,
      cards: cngMeetingDecisionCardsView,
      dashboard: cngMeetingDecisionDashboardView,
  }),
  form: cngMeetingDecisionFullForm,
  forms: { full: cngMeetingDecisionFullForm, context: cngMeetingDecisionContextForm, mini: cngMeetingDecisionMiniForm, lookup: cngMeetingDecisionLookupForm },
  menu: cngMeetingDecisionMenu,
} as IRecordTypeDefinition;
